var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.label,"type":_vm.classForField,"message":_vm.firstErrorForField}},[_c('b-input',_vm._b({class:_vm.classForField,attrs:{"name":_vm.field,"data-vv-name":_vm.field}},'b-input',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }